import * as yup from "yup";
export const loginSchema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup
        .string()
        .min(8)
        .required()
        .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[-._!"`'#%&,:;<>=@{}~$()*+/\\?[]^|])[A-Za-z\d-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|]{8,}$/, "Must contain at least 8 characters, one letter, one number and one special character"),
});
